import React from 'react'
import { Grid, Box, Typography, Divider, Stack, Link } from '@mui/material';

import { AnimalCard, SkeletonCard } from '../content/card';
import AnimalFilter from '../filter/main';


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";
import CountUp from 'react-countup';

import Mensch from '../../resources/Mensch.jpg';


const you = { picture_url: Mensch, name: 'Du', breed: 'Mensch', breed_id: '0', description: 'Für dich ist ein Hund mehr als ein Haustier. Du hast die Zeit dich um Ihn zu kümmern und mehrfach am Tag raus zu gehen. Der perfekte Hund für dich wartet schon in einem der zahlreichen Tierheime in Deutschland!', dog_link: 'https://pocketpet.de', shelter: { 'state': 'Erde' } }




export default function About(props) {
    //The xs, sm, md, lg, and xl props


    const data = props.data
    const loading = props.loading


    return (
        <Grid
            container
            spacing={7}
            direction="row"
            alignItems="center"
            justifyContent="center"
            mt={-5}
            mb={20}>

            <Grid item xs={12} >
                <Typography variant='h2' component='h1'>
                    PocketPet - Das online Tierheim
                </Typography>
            </Grid>


            <Grid item xs={12}>
                <Typography variant='body1'>
                    PocketPet ist eine zeitgemäße Online-Tiervermittlung, die dir dabei hilft, deinen Traumhund zu finden.
                    Wir finden, dass du einen Hund verdienst, der voll und ganz deinen Vorstellungen entspricht.
                    Und damit wollen wir dich nicht dem Züchter überlassen.
                    Denn der Hund, den du suchst, existiert schon und wartet nur, bis du ihn abholen kommst.
                </Typography>
            </Grid>


            <Grid item xs={12}>
                <NumberPresentation data={data} />
            </Grid>


            <Grid item xs={12}>
                <Typography variant='body1'>
                    PocketPet beinhaltet aktuell {data.count} Hunden aus {data.breeds} verschiedenen Hunderassen.
                    Oft haben Hundebesitzer eine genau Vorstellung von Ihrem Hund.
                    Es ist aber nahezu unmöglich, sich einen Überblick über jedes der {data.shelters} Tierheime, die nach dem <Link href='https://www.tierschutzbund.de/organisation/ueber-uns/tierheime/' target='_blank' rel='norefferer' title='Zum Tierschutzbund'>Deutschen Tierschutzbund</Link> gelistet sind, zu verschaffen.
                    Diese Aufgabe übernimmt PocketPet.
                    Alle hier aufgelisteten Hunde sind stehts abgeglichen mit den Websites der einzelnen Tierheime.
                    Statt einen Hund vom Züchter zu kaufen, kannst du also hier deinen Traumhund finden.
                </Typography>


            </Grid>



            <Grid item xs={12} >
                <Typography variant='h2' component='h2'>
                    Alles auf eine Karte
                </Typography>
            </Grid>


            <Grid item xs={12}>
                <Typography variant='body1'>
                    Um eine kompakte Zusammenfassung zu ermöglichen, sind alle relevanten Informationen auf einer Karte zusammengefasst.
                    In der ersten Zeile sind Name, Geschlecht und eine oder mehrere Hunderassen zu sehen, falls der Hund ein Mischling ist.
                    Alle gefundenen Bilder befinden sich in einer scrollbaren Box.
                    Du musst nur auf ein Bild klicken, und es nach links ziehen, um weitere zu sehen.
                    Darunter findet sich ein Auszug der Beschreibung.
                    Häufig lässt sich in den ersten Zeilen der Beschreibung schon der Charakter des Hundes oder dessen Lebenssituation erkennen.
                    Auf dem letzten Ende der Karte stehen die Merkmale des Hundes zusammengefasst.
                </Typography>
            </Grid>




            <Grid item md={2} sx={{ display: { xs: "none", xl: "block" } }} />
            <Grid item xs={12} md={5} xl={3}>
                <AnimalCard dog={you}></AnimalCard>
            </Grid>
            <Grid item xs={12} md={2} xl={2}>
                <Typography m={2} align='center' variant='body1'>
                    Du suchst deinen Hund
                </Typography>
                <Divider />
                <Typography m={2} align='center' variant='body1'>
                    Dein Hund wartet auf dich
                </Typography>
            </Grid>
            <Grid item xs={12} md={5} xl={3}>
                {loading ? <SkeletonCard /> : <CardCarousel dogs={data.dogs} />}
            </Grid>
            <Grid item xs={0} xl={2} />





            <Grid item xs={12} >
                <Typography variant='h2' component='h2'>
                    Wer suchet, der findet
                </Typography>
            </Grid>


            <Grid item xs={12}>
                <Typography variant='body1'>
                    PocketPet bietet die Möglichkeit, bei allen vorhandenen Hunden zielgenau nach Eigenschaften wie Rasse, Geschlecht und Alter zu suchen.
                    Du kannst einfach die Filter anwenden, auf dem "Filtern" Button klicken und eine Ergebnisliste basierend auf deinen Suchkriterien finden.
                </Typography>
            </Grid>

            <Grid item xs={12}>
                <AnimalFilter oneLine={true}></AnimalFilter>
            </Grid>


            <Grid item xs={12}>
                <Typography variant='body1'>
                    Da du jetzt weißt, was dich auf PocketPet erwartet, nichts wie los! Denn dein Hund exisitiert schon. Du musst ihn nur finden.
                </Typography>
            </Grid>

        </Grid>

    )
}

function CardCarousel(props) {

    var slider_settings = {
        className: "slider variable-width",
        dots: false,
        autoPlaySpeed: 7000,
        autoplay: true,
        draggable: false,
        fade: true,
        //pauseOnFocus: true,
        arrows: false

    }

    return <Slider {...slider_settings}>

        {props.dogs.map((dog, index) => (
            <div key={index}>
                <AnimalCard dog={dog}></AnimalCard>
            </div>
        ))}
    </Slider>;
}

function NumberPresentation(props) {
    const data = props.data

    return (
        <Grid item xs={12}>
            {/**<Divider mb={5} />**/}

            <Stack direction="row" spacing={0} mt={4} justifyContent='space-evenly'>
                <Box>
                    <Typography variant='h2' component='p'>
                        <CountUp end={data.count} />
                    </Typography>
                    <Typography variant='body1' textAlign='center'>
                        Hunde
                    </Typography>
                </Box>

                <Box>
                    <Typography variant='h2' component='p'>
                        <CountUp end={data.breeds} />
                    </Typography>
                    <Typography variant='body1' textAlign='center'>
                        Rassen
                    </Typography>
                </Box>


                <Box>
                    <Typography variant='h2' component='p'>
                        <CountUp end={data.shelters} />
                    </Typography>
                    <Typography variant='body1' textAlign='center'>
                        Tierheime
                    </Typography>
                </Box>

            </Stack>


        </Grid>
    )
}
